module.exports = __webpack_public_path__ + "school/img/404.b90099f4.png";